import { useState } from "react";

export default function (breakpoint: string) {
  const mq = window.matchMedia(`(max-width: ${breakpoint})`);
  const [isMatching, setIsMatching] = useState<Boolean>(mq.matches);

  mq.addEventListener("change", (e) => setIsMatching(e.matches));
  return isMatching;
}
